import { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import Loading from '../Loading/Loading';

const PublicRoute = ({ children, helmetTitle }) => {
  return (
    <>
      <Helmet>
        <title>{helmetTitle}</title>
      </Helmet>
      <Suspense fallback={<Loading />}>{children}</Suspense>
    </>
  );
};

export default PublicRoute;
